import { LabelAlign } from "@certn/cascadia-react/components/types";
import { css } from "@emotion/css";
import { mergeProps } from "react-aria";
import {
  TextField as AriaTextField,
  TextFieldProps,
} from "react-aria-components";

import { sharedStyles } from "../utils";

interface Props extends TextFieldProps {
  labelAlign?: LabelAlign;
}

export function TextField(props: Props) {
  const { labelAlign = "vertical" } = props;
  const className = css(sharedStyles.field);

  return (
    <AriaTextField
      {...mergeProps(props, { className })}
      data-label-orientation={labelAlign}
    />
  );
}
